import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-917a87695cc943acae31ac6086276c76/input/1603358965782/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { format } from 'date-fns';
import request from "../../util/request";
export default {
  name: 'Account',
  data: function data() {
    return {
      switchAccount: null
    };
  },
  computed: {
    isHuaFeiPayType: function isHuaFeiPayType() {
      return this.vip.data.servicetype === 'HLWHF';
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var account;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.vip.isVip()) {
                _context.next = 14;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return this._reqRelatedVip();

            case 4:
              account = _context.sent;
              this.switchAccount = account;
              $('#accountText').text(account.name + '账号是腾讯视频VIP');
              $('#btnSwitchAccount').removeClass('none');
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);

              if (this.vip.isExpire()) {
                $('#accountText').text('您的腾讯视频VIP已过期');
                $('#accountIcon').removeClass('none');
              } else {
                $('#accountText').text('您还不是腾讯视频VIP');
              }

              if ($('#btnSwitchAccount').css('display') === 'none') {
                $('#accountText').parent('.management_txt').addClass('cl_pd');
              }

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 10]]);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    formatDate: function formatDate(date) {
      if (typeof date === 'number') {
        date = new Date(date);
      } else if (typeof date === 'string') {
        date = new Date(date.replace(/-/g, '/'));
      }

      return format(date, 'YYYY-MM-DD');
    },
    _reqRelatedVip: function () {
      var _reqRelatedVip2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return request('//access.video.qq.com/trans/pay.video.qq.com/fcgi-bin/check_bindaccount?vappid=68106135&vsecret=e667570eb833960cc41051d498df1c233308eb195dba2cc3&otype=json');

              case 2:
                res = _context2.sent;

                if (!(res && res.result && res.result.code === 0 && res.isVip === 1)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", {
                  id: res.account_id,
                  type: res.bind_type,
                  name: res.bind_type === 'qq' ? 'QQ' : '微信'
                });

              case 7:
                throw new Error('获取关联账号会员信息失败!');

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function _reqRelatedVip() {
        return _reqRelatedVip2.apply(this, arguments);
      }

      return _reqRelatedVip;
    }()
  }
};